export const SUB_URL = 'sub';
export const CHAT_CLASS = 'chat';
export const DISPLAY_NEXT_NODE_TIMEOUT = 250;
export const NODE_KEYS_SHOULD_RENDER_ONCE: string[] = [];
export const PATH_TO_SAVE_RESPONSES = 'surveyEntrySave.responses';
